export default __webpack_public_path__ + "static/media/sho3.cea88d22.jpg";